import React, { useEffect, useId, useRef } from 'react';
const Modal = ({ isOpen, onClose, title, children, footer, size = 'md', closeButton = true, className = '', }) => {
    const titleId = useId();
    const dialogRef = useRef(null);
    useEffect(() => {
        if (!isOpen) {
            document.body.classList.remove('modal-open');
            return undefined;
        }
        const previouslyFocused = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        document.body.classList.add('modal-open');
        const focusFrame = window.requestAnimationFrame(() => {
            const preferredTarget = dialogRef.current?.querySelector('[data-autofocus]');
            (preferredTarget || dialogRef.current)?.focus();
        });
        const handleKeyDown = (event) => {
            if (event.key === 'Escape')
                onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            window.cancelAnimationFrame(focusFrame);
            document.removeEventListener('keydown', handleKeyDown);
            document.body.classList.remove('modal-open');
            previouslyFocused?.focus();
        };
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    const sizeClass = size !== 'md' ? `modal-${size}` : '';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `modal fade in ${className}`.trim(), style: { display: 'block' }, onClick: onClose, role: "dialog", "aria-modal": "true", "aria-labelledby": title ? titleId : undefined, "aria-label": title ? undefined : 'Dialog' },
            React.createElement("div", { ref: dialogRef, className: `modal-dialog ${sizeClass}`.trim(), onClick: (e) => e.stopPropagation(), tabIndex: -1 },
                React.createElement("div", { className: "modal-content" },
                    title && (React.createElement("div", { className: "modal-header" },
                        closeButton && (React.createElement("button", { type: "button", className: "close", onClick: onClose, "aria-label": "Close" },
                            React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
                        React.createElement("h4", { className: "modal-title", id: titleId }, title))),
                    React.createElement("div", { className: "modal-body" }, children),
                    footer && React.createElement("div", { className: "modal-footer" }, footer)))),
        React.createElement("div", { className: "modal-backdrop fade in" })));
};
export default Modal;
